const loadDataActionTypes = {
  RESET_STATE: 'RESET_STATE',
  REQUEST: 'REQUEST',
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
};

export { loadDataActionTypes as default };
